// src/pages/WandlerEditor.jsx
import { C, Field, TextInput, NumberInput, Select, Row } from './formui';

const WANDLER_TYPEN = [
  { value: 'strom', label: 'Stromwandler' },
  { value: 'spannung', label: 'Spannungswandler' },
];

// nurStrom: NS-Messung - dort gibt es keine Spannungswandler (Anna-Lena 18.09.2026).
export default function WandlerEditor({ items, setItems, nurStrom = false }) {
  const add = () => setItems([...items, { wandler_typ: 'strom', hersteller: '', typ: '', seriennummer_l1: '', seriennummer_l2: '', seriennummer_l3: '', bemessunguebersetzung: '', spannung_e_n: '', spannung_u_x: '', bemessungsbuerde_va: null, genauigkeitsklasse: '', eichjahr: null, frequenz_hz: 50 }]);
  const remove = (i) => setItems(items.filter((_, idx) => idx !== i));
  const update = (i, k, v) => setItems(items.map((it, idx) => idx === i ? { ...it, [k]: v } : it));
  return (
    <>
      {items.length === 0 ? (
        <div style={{ padding: 14, color: C.gray500, fontSize: 15, fontStyle: 'italic', textAlign: 'center' }}>Keine Wandler. Optional.</div>
      ) : items.map((w, i) => (
        <div key={i} style={{ padding: 12, marginBottom: 10, background: C.gray100, borderRadius: 8 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
            <div style={{ fontWeight: 700, color: C.navy, fontSize: 15 }}>Wandler {i + 1}</div>
            <button onClick={() => remove(i)} style={{ background: C.redBg, color: C.red, border: 'none', borderRadius: 8, padding: '8px 14px', minHeight: 44, cursor: 'pointer', fontSize: 14, fontWeight: 700 }}>Entfernen</button>
          </div>
          <Row columns={2}>
            <Field label='Typ' required><Select value={w.wandler_typ} onChange={v => update(i, 'wandler_typ', v)} options={nurStrom && w.wandler_typ !== 'spannung' ? WANDLER_TYPEN.filter(o => o.value === 'strom') : WANDLER_TYPEN}/></Field>
            <Field label='Hersteller'><TextInput value={w.hersteller} onChange={v => update(i, 'hersteller', v)}/></Field>
          </Row>
          <Row columns={3}>
            <Field label='Seriennr. L1'><TextInput value={w.seriennummer_l1} onChange={v => update(i, 'seriennummer_l1', v)}/></Field>
            <Field label='Seriennr. L2'><TextInput value={w.seriennummer_l2} onChange={v => update(i, 'seriennummer_l2', v)}/></Field>
            <Field label='Seriennr. L3'><TextInput value={w.seriennummer_l3} onChange={v => update(i, 'seriennummer_l3', v)}/></Field>
          </Row>
          {w.wandler_typ === 'strom' ? (
            <Field label='Bemessungsuebersetzung [A]' hint='z.B. "200/5"'><TextInput value={w.bemessunguebersetzung} onChange={v => update(i, 'bemessunguebersetzung', v)}/></Field>
          ) : (
            <Row columns={2}>
              <Field label='Spannung e-n'><TextInput value={w.spannung_e_n} onChange={v => update(i, 'spannung_e_n', v)}/></Field>
              <Field label='Spannung u-x'><TextInput value={w.spannung_u_x} onChange={v => update(i, 'spannung_u_x', v)}/></Field>
            </Row>
          )}
          <Row columns={3}>
            <Field label='Genauigkeitsklasse' hint='z.B. "0,5s"'><TextInput value={w.genauigkeitsklasse} onChange={v => update(i, 'genauigkeitsklasse', v)}/></Field>
            <Field label='Eichjahr'><NumberInput value={w.eichjahr} onChange={v => update(i, 'eichjahr', v)}/></Field>
            <Field label='Frequenz [Hz]'><NumberInput value={w.frequenz_hz} onChange={v => update(i, 'frequenz_hz', v)}/></Field>
          </Row>
        </div>
      ))}
      <button onClick={add} style={{ marginTop: 4, padding: '10px 16px', background: C.navy, color: C.yellow, border: 'none', borderRadius: 7, cursor: 'pointer', fontWeight: 700, fontSize: 15 }}>+ Wandler hinzufuegen</button>
    </>
  );
}
